import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LayoutDashboard, GraduationCap, Sparkles, Library, BookOpen, User, LogOut, HeartHandshake, ShieldCheck, Home, ShieldPlus } from "lucide-react";
import { Button } from "@/components/ui/button";

const NAV = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard" },
  { to: "/beasiswa", label: "Portal Beasiswa", icon: GraduationCap, testid: "nav-beasiswa" },
  { to: "/paper", label: "AI Paper & Slide", icon: Sparkles, testid: "nav-paper" },
  { to: "/direktori-jurnal", label: "Direktori Jurnal", icon: Library, testid: "nav-jurnal" },
  { to: "/tugas-akhir", label: "Ide Tugas Akhir", icon: BookOpen, testid: "nav-ta" },
  { to: "/haki", label: "Pendaftaran HAKI", icon: ShieldPlus, testid: "nav-haki" },
  { to: "/donasi", label: "Dukung Kami", icon: HeartHandshake, testid: "nav-donasi" },
  { to: "/profil", label: "Profil Saya", icon: User, testid: "nav-profil" },
];

export default function AppShell({ children }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const location = useLocation();
  const items = [...NAV];
  if (user?.is_admin) items.push({ to: "/admin", label: "Admin Panel", icon: ShieldCheck, testid: "nav-admin" });
  const isDashboard = location.pathname === "/dashboard";
  return (
    <div className="min-h-screen bg-[#F3F4F1]">
      <aside className="hidden lg:flex fixed inset-y-0 left-0 w-64 bg-[#0F2922] text-[#FAFA96] flex-col">
        <Link to="/dashboard" className="flex items-center justify-center px-4 py-4 border-b border-white/10 bg-white/95">
          <img src="https://customer-assets-v7afamib.emergentagent.net/job_thesis-mate/artifacts/l29gu6p6_Untitled%20design%20%283%29.png" alt="kawantugas.id" className="h-16 w-auto" />
        </Link>
        <nav className="flex-1 py-4 px-3 space-y-1">
          {items.map(({ to, label, icon: Icon, testid }) => (
            <NavLink key={to} to={to} data-testid={testid}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm ${isActive ? "bg-[#D97706] text-white" : "hover:bg-white/10"}`}>
              <Icon size={18} /><span>{label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/10">
          <div className="text-xs opacity-70 mb-1">Masuk sebagai</div>
          <div className="text-sm font-semibold truncate">{user?.name}</div>
          <div className="text-xs opacity-70 mb-3 truncate">{user?.email}</div>
          <Button variant="outline" size="sm" className="w-full border-white/30 bg-transparent hover:bg-white/10 text-[#FAFA96]" onClick={async () => { await logout(); nav("/"); }} data-testid="logout-button">
            <LogOut size={14} className="mr-2" /> Keluar
          </Button>
        </div>
      </aside>
      <header className="lg:hidden bg-white border-b border-slate-200 px-4 py-2.5 flex items-center justify-between sticky top-0 z-40">
        <Link to="/dashboard" className="flex items-center gap-2">
          <img src="https://customer-assets-v7afamib.emergentagent.net/job_thesis-mate/artifacts/l29gu6p6_Untitled%20design%20%283%29.png" alt="kawantugas.id" className="h-10 w-auto" />
        </Link>
        <Button size="sm" variant="outline" className="border-slate-300" onClick={async () => { await logout(); nav("/"); }}>Keluar</Button>
      </header>
      <main className="lg:pl-64 min-h-screen">
        {!isDashboard && (
          <div className="sticky top-0 lg:top-0 z-30 backdrop-blur bg-[#F3F4F1]/85 border-b border-slate-200/70">
            <div className="max-w-6xl mx-auto px-6 lg:px-10 py-3 flex items-center justify-between gap-3">
              <Link
                to="/dashboard"
                data-testid="home-button"
                className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#0F2922] text-[#FAFA96] text-sm font-semibold shadow-sm hover:bg-[#173E34] hover:shadow-md transition"
              >
                <Home size={16} /> <span>Home</span>
              </Link>
              <div className="hidden sm:flex items-center gap-2 text-xs text-slate-500">
                <span className="mono">kawantugas.id</span>
                <span>·</span>
                <span className="capitalize">{(location.pathname.replace("/", "").replace("-", " ")) || "dashboard"}</span>
              </div>
            </div>
          </div>
        )}
        <div className="max-w-6xl mx-auto p-6 lg:p-10">{children}</div>
      </main>
    </div>
  );
}
